import { render, staticRenderFns } from "./CourierServiceCreate.vue?vue&type=template&id=220ae453&scoped=true&"
import script from "./CourierServiceCreate.vue?vue&type=script&lang=js&"
export * from "./CourierServiceCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220ae453",
  null
  
)

export default component.exports